import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useActiveSceneCurvedImageTrackingRadius, useGetActiveSceneTrackingType } from '../../../utils';
import Grid from '../Grid/Grid';
import { ITrackingTypes } from '../r3f-components/component-data-structure';
import ShadowPlane from '../r3f-components/components/ShadowPlane';
import Background360Placeholder from './Background360Placeholder/Background360Placeholder';
import FaceTrackingPlaceholder from './FaceTrackingPlaceholder/FaceTrackingPlaceholder';
import ImageTrackingPlaceholder from './ImageTrackingPlaceholder/ImageTrackingPlaceholder';
const SceneDefaultContent = () => {
    const isSceneInContentDoc = useSelector((state) => state.contentReducer.contentDoc.componentsById[state.contentReducer.contentDoc.rootComponentId]?.children?.length > 0);
    const activeSceneTrackingType = useGetActiveSceneTrackingType();
    const curvedTrackingRadius = useActiveSceneCurvedImageTrackingRadius();
    if (!isSceneInContentDoc)
        return null;
    switch (activeSceneTrackingType) {
        case ITrackingTypes.image:
            return _jsxs(_Fragment, { children: [_jsx(ImageTrackingPlaceholder, {}), !!curvedTrackingRadius ? null : _jsx(ShadowPlane, { position: [0, 0, 0] })] });
        case ITrackingTypes.face:
            return _jsx(FaceTrackingPlaceholder, {});
        case ITrackingTypes.world:
            return _jsx(Grid, {});
        case ITrackingTypes.content360:
            return _jsx(Background360Placeholder, {});
        case ITrackingTypes.noTrackingScreen:
            return null;
        default:
    }
    return null;
};
export default memo(SceneDefaultContent);
